import React from 'react';

export const withToggle = Wrapped => props => (
    <Wrapped
        {...props}
        kind="toggle"
        reverse={true}
        stretch={true}
    />
);
